import { useEffect, useRef } from "react";

// Soft neon glow that follows the cursor
export default function CursorGlow() {
  const ref = useRef(null);
  useEffect(() => {
    const onMove = (e) => {
      if (ref.current) ref.current.style.transform = `translate(${e.clientX - 300}px, ${e.clientY - 300}px)`;
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);
  return (
    <div
      ref={ref}
      aria-hidden
      className="hidden md:block fixed top-0 left-0 w-[600px] h-[600px] rounded-full pointer-events-none z-[1] transition-transform duration-300 ease-out"
      style={{ background: "radial-gradient(circle, rgba(34,211,238,0.09), rgba(59,130,246,0.05) 40%, transparent 70%)" }}
    />
  );
}
